import { Subject } from 'rxjs';
import { Config } from '../../config';
import { Order } from '../../config/order';
import { Product } from '../../config/product';
import { ProductType } from '../../config/product-type';
import { IUpSellChangeEvent, IUpSellEvent, IUpSellQuantityChangeResponse } from '../../config/upsell-response';
import { UpSellDonationView } from '../../view/upsell/upsell-donation-view';
import { Form } from '../form';
import { FormTypes } from '../form-types';


export class UpSellDonationForm extends Form {
    private products: Product[] = [];
    view: UpSellDonationView = new UpSellDonationView();
    currentProduct: any = {};
    type = FormTypes.UpSellDonation;

    upSellProducts: Product[] = [];


    async init(config: Config, callback: any, subject: Subject<IUpSellEvent>) {
        await super.init(config, callback);
        this.parentSubject = subject;
        this.upSellProducts = this.config.widget.data.result.upsell.products;

        if (this.upSellProducts) {
            this.products = this.upSellProducts.filter((product: Product) => product.type === ProductType.DONATION);
        }
        return Promise.resolve();
    }

    async render() {
        if (this.products.length) {
            this.view.donationRender({
                products: this.products,
                currency: this.config.settings.currency,
                callback: this.onDonationChange.bind(this),
                isOneProduct: this.upSellProducts.length === 1
            });
        }

        return Promise.resolve();
    }

    submit(order: Order) {
        return Promise.resolve(order);
    }

    onDonationChange(product: Product, amount: number, frequency: string) {

        if (this.parentSubject) {
            this.parentSubject.next({
                prodType: 'donation',
                evType: IUpSellChangeEvent.SelectChange,
                product: product,
                frequency,
                amount
            });
        }
    }

    private setDiscount(selectedProducts: Array<any>) {
        if (this.config.settings && this.config.settings.discountId) {
            const coupon = this.config.settings.discountId;
            return selectedProducts.map((item: any) => {
                item.discountId = coupon.id;
                return item;
            });
        }
        return selectedProducts;
    }

    setAmountFromUrl(urlAmount: string) {
        const product = this.upSellProducts[0];
        if (product.type === ProductType.DONATION) {
            product.amount = Number(urlAmount);
            this.paymentData.amount = Number(urlAmount);
            this.triggerEvent('amountChange');
        }
    }
}
